import React from 'react';
import {
    ConfigsService as GeneralConfigService,
    LocaleService,
    WindowProxy,
} from '@sm360/widget-commons-core-services';
import { HistoryService } from '@sm360/widget-commons-general';

import Deposit from 'deposit/components/Deposit/Deposit.jsx';

class DepositProvider extends React.Component {
    constructor(props) {
        super(props);

        GeneralConfigService.setOrganizationId(props.organizationId);
        GeneralConfigService.setOrganizationUnitId(props.organizationUnitId);
        GeneralConfigService.setOrganizationUnitLocation(props.organizationUnitLocation);
        GeneralConfigService.setWebsiteId(props.websiteId);
        GeneralConfigService.setLocation(props.location);

        LocaleService.setLocale(props.locale);
        this.onUnload = this.onUnload.bind(this);
    }

    componentDidMount() {
        const $window = WindowProxy.get();
        if ($window) {
            $window.addEventListener('beforeunload', this.onUnload);
        }
    }

    componentWillUnmount() {
        this.onUnload();
    }

    onUnload() {
        HistoryService.add(WindowProxy.location().href);
    }

    render() {
        return <Deposit stripePublishableKey={this.props.stripePublishableKey} onSuccess={this.testFunction} />;
    }
}

DepositProvider.propTypes = {
    locale: React.PropTypes.string.isRequired,
    websiteId: React.PropTypes.number.isRequired,
    organizationUnitId: React.PropTypes.number.isRequired,
    organizationId: React.PropTypes.number.isRequired,
    organizationUnitLocation: React.PropTypes.string.isRequired,
    location: React.PropTypes.string.isRequired,
    stripePublishableKey: React.PropTypes.string.isRequired,
};

DepositProvider.displayName = 'DepositProvider';

export default DepositProvider;



// WEBPACK FOOTER //
// ./src/DepositProvider.jsx